export const TickerAnimation=()=>{
    
    
    return(
        <div className="hero-section_ticker">
            <div className="hero-section_ticker-wrapper">
                <div className="hero-section_ticker-el">
                    <img src={require("../../../../../static/IMAGE-ticker-paper.png")}/>
                    <p>put some fire in your belly</p>
                </div>
                <div className="hero-section_ticker-el">
                    <img src={require("../../../../../static/IMAGE-ticker-paper.png")}/>
                    <p>put some fire in your belly</p>
                </div>
                <div className="hero-section_ticker-el">
                    <img src={require("../../../../../static/IMAGE-ticker-paper.png")}/>
                    <p>put some fire in your belly</p>
                </div>
                <div className="hero-section_ticker-el">
                    <img src={require("../../../../../static/IMAGE-ticker-paper.png")}/>
                    <p>put some fire in your belly</p>
                </div>
                <div className="hero-section_ticker-el">
                    <img src={require("../../../../../static/IMAGE-ticker-paper.png")}/>
                    <p>put some fire in your belly</p>
                </div>
            </div>
        </div>
    )
}